import { ThemeProvider } from "@emotion/react";
import { theme } from "@financial-advisory/theme";
import "@financial-advisory/ui/components/pdf-viewer/src/style/pdf-viewer.css";
import { ModalProvider } from "@unlikelyai-magic/ui/modals";
import "./App.scss";
import { AppRouter } from "./AppRouter";

export default () => (
  <ThemeProvider theme={theme}>
    <ModalProvider>
      <AppRouter />
    </ModalProvider>
  </ThemeProvider>
);
